import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axiApi from "ApiCaller";
import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";

const translations = {
    es: {
        download: "Descargar",
        download_template: "Descarga la plantilla de inventario necesaria para",
    },
    en: {
        download: "Download",
        download_template: "Download the inventory template needed for",
    },
};

const TabDownload = ({user, token, setKeyTab}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);

    const onClickDownload = () => {
        axiApi
            .get("/api/inventory/download/", {
                responseType: "blob",
            })
            .then((resp) => {
                let href = URL.createObjectURL(resp.data);
                let link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "template-inventory.xlsx");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    return (
        <div
            className="container-fluid"
            style={{height: "calc(100vh - 220px)", position: "relative"}}>
            <div className="row">
                <div className="col-md-10 m-auto pt-5">
                    <div className="row">
                        <div className="col-md-3 col-12 d-flex justify-content-center align-items-center">
                            <FontAwesomeIcon
                                icon="fa-regular fa-file-excel"
                                style={{fontSize: "14rem", color: "#c2c2c2"}}
                            />
                        </div>
                        <div className="col-md-9 col-12 text-center">
                            <h3 className="mb-4">{_TC("download_template")}</h3>
                            <h3 className="mb-4">{user.panel.name}</h3>
                            <button
                                className="btn btn-outline-primary mt-4"
                                onClick={onClickDownload}>
                                {_TC("download")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="col-12 text-end p-3 bg-form"
                style={{position: "absolute", bottom: "0", right: "0"}}>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setKeyTab("select")}>
                    {_Tf("labels.next")}
                </button>
            </div>
        </div>
    );
};

export default TabDownload;
